import { DumpYardTemplate } from "../../../models";

export const getDumpYardTemplate = (data: any): DumpYardTemplate => {
  return {
    id: data.id,
    address: data.attributes.address,
    zip: data.attributes.zip,
    name: data.attributes.name || "",
    latitude: data.attributes.latitude,
    longitude: data.attributes.longitude,
    isDumpYard: data.attributes.is_dump_yard,
    isStorage: data.attributes.is_storage,
    isQuickStop: data.attributes.is_quick_stop,
    // A null/absent flag (legacy rows) means active.
    isActive: data.attributes.is_active == null ? true : Boolean(data.attributes.is_active),
    city: data.attributes.city || "",
    pricePerTon:
      data.attributes.price_per_ton != null
        ? Number(data.attributes.price_per_ton)
        : null,
    minDumpWeight:
      data.attributes.min_dump_weight != null
        ? Number(data.attributes.min_dump_weight)
        : null,
    serviceTimeOverride:
      data.attributes.service_time_override != null
        ? Number(data.attributes.service_time_override)
        : null,
    operatingHoursStart:
      data.attributes.operating_hours_start != null
        ? Number(data.attributes.operating_hours_start)
        : null,
    operatingHoursEnd:
      data.attributes.operating_hours_end != null
        ? Number(data.attributes.operating_hours_end)
        : null,
    wasteTypes: data.attributes.waste_types
      ? String(data.attributes.waste_types)
          .split(",")
          .map((w: string) => w.trim())
          .filter(Boolean)
      : [],
  };
};

export const getDumpYardTemplates = (data: any): DumpYardTemplate[] => {
  return data.map(getDumpYardTemplate);
};
